import { Component, Input } from '@angular/core';
import { StructCapCRMStatus, StructCapCRMStatusLabels } from '../../enums/struct-cap-crm-status';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DateConverterService } from '../../../core/data-services/date-converter.service';
import { StructCapCrmStatusReason, StructCapCrmStatusReasonLabels } from '../../enums/struct-cap-crm-status-reason';
import { DateTime } from 'luxon';

@Component({
    selector: 'rms-struct-cap-crm-status-change-modal',
    templateUrl: './struct-cap-crm-status-change-modal.component.html',
    styleUrls: ['./struct-cap-crm-status-change-modal.component.scss'],
    standalone: false
})
export class StructCapCrmStatusChangeModalComponent {

  @Input() newStatus: StructCapCRMStatus;
  @Input() dateRequired: boolean;

  public noteModalContent: string;
  public silenceUntilDate: DateTime;
  public shouldSendNotification = true;
  public selectedReason: string;

  public readonly StructCapStatusLabels = StructCapCRMStatusLabels;
  public readonly StructCapStatusReasonLabels = StructCapCrmStatusReasonLabels;
  public readonly curDate = DateTime.now();

  constructor(
    private modal: NgbActiveModal
  ) { }

  public submit() {
    if (!this.noteModalContent) {
      return;
    }

    this.modal.close({
      noteContent: this.noteModalContent,
      silenceUntilDate: this.silenceUntilDate,
      shouldNotify: this.shouldSendNotification,
      statusReason: StructCapCrmStatusReason[this.selectedReason]
    });
  }

  public dismiss() {
    this.modal.dismiss();
  }

  get cannotSubmit(): boolean {
    return !this.noteModalContent || (this.dateRequired && !this.silenceUntilDate);
  }
}
